import paths from './paths'
import countryList from './countries'
import sexList from './sexes'

export const routes = paths
export const countries = countryList
export const sexes = sexList
export const API_ROUTE = process.env.VUE_APP_API_URL
